// extracted by mini-css-extract-plugin
export default {"mainContainer":"ProductItem_mainContainer__oVZr9","productImage":"ProductItem_productImage__qMuBV","text":"ProductItem_text__TMSIz"};